<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="650" class="pa-4">
      <v-card-title class="screen-title">ワンタイムURL発行</v-card-title>
      <div v-if="expired" class="ml-4 pt-4">
        パスワードの有効期限が切れています。ワンタイムURL発行を実施してください。
      </div>
      <v-card-text class="pt-2">
        <validation-observer v-slot="{ handleSubmit }" as="div">
          <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
            <div class="pa-1">
              <validation-provider
                label="ログインID"
                name="loginId"
                :rules="{ required: true, login_id_with_v_number: true }"
                v-model="form.loginId"
                v-slot="{ componentField, errorMessage, meta }"
              >
                <v-row>
                  <v-col>
                    <app-badge
                      item="ログインID"
                      :msg="$filter.message(`info_LoginId_vnumber`)"
                      :isRequired="true"
                    ></app-badge>
                    <app-form-input
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </v-col>
                </v-row>
              </validation-provider>
            </div>
            <div class="pa-1">
              <validation-provider
                label="メールアドレス"
                name="email"
                :rules="{
                  required: true,
                  is_email: true,
                  max: { length: 127 },
                }"
                v-model="form.email"
                v-slot="{ componentField, errorMessage, meta }"
              >
                <v-row>
                  <v-col>
                    <app-badge
                      item="メールアドレス"
                      :msg="$filter.message('info_mail')"
                      :isRequired="true"
                    ></app-badge>
                    <small
                      >・メールアドレスはログインID情報として登録済みの情報をご指定ください。<br />
                      ・メールアドレスは大文字、小文字が区別されますのでご注意ください。</small
                    >
                    <app-form-input
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </v-col>
                </v-row>
              </validation-provider>
            </div>
            <div class="pa-1">
              再発行手続きを行うメールを送付します。よろしいですか？
            </div>
            <v-card-actions>
              <v-list-item class="w-100 pa-1">
                <template v-slot:append>
                  <v-btn color="primary" variant="flat" type="submit"
                    >送信</v-btn
                  >
                  <v-btn
                    @click="$router.back()"
                    variant="outlined"
                    color="primary"
                    >いいえ</v-btn
                  >
                </template>
              </v-list-item>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { PostOnetime } from "@/apis/PasswordApi";

export default defineComponent({
  name: "OneTimeUrlIssue",
  props: {
    /** true: パスワード有効期限切れの場合（メッセージを画面に表示） */
    expired: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    /** ログインIDの入力初期値 */
    loginId: {
      type: String as PropType<string>,
      default: "",
    },
  },
  data() {
    return {
      form: {
        loginId: this.loginId,
        email: "",
        oneTimeUrl: `${window.location.origin}/password/reset`,
      } as PostOnetime,
    };
  },
  methods: {
    async submit() {
      await this.$api.password.postOnetime(this.form);
      await this.$router.push("/password/one-time-url/complete");
    },
  },
});
</script>
<style lang="scss" scoped>
.ml-4 {
  color: red;
}
</style>
